module.exports = __webpack_public_path__ + "static/img/defalut-logo.a99ac774.png";